import { render, staticRenderFns } from "./Aside_bSales.vue?vue&type=template&id=766e5568&scoped=true"
import script from "./Aside_bSales.vue?vue&type=script&lang=js"
export * from "./Aside_bSales.vue?vue&type=script&lang=js"
import style0 from "./Aside_bSales.vue?vue&type=style&index=0&id=766e5568&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "766e5568",
  null
  
)

export default component.exports